<template>
    <div>
        <van-pull-refresh v-model="isInfoLoading" @refresh="onRefresh"
                          pulling-text="Se puede actualizar desplegando..."
                          loosing-text="Se puede actualizar liberando..."
                          loading-text="En carga..."
        >
        <div class="audithome_wrap" style="height: 40px; background: none;">
            <div class="audithome_head">
                <div class="audithome_hleft" style="color: #333333;">Superapoyomax</div>
                <div class="audithome_hright">
                    <div class="audithome_hrimg">
                        <!--<img src="../../assets/img/audithome_icon01.png" />-->
                        <!--<van-icon name="contact-o" size="24" color="#333333" />-->
                    </div>
                    <div class="audithome_hrimg">
                        <!--<img src="../../assets/img/audithome_icon02.png" />-->
                        <!--<van-icon name="ellipsis" size="24" color="#333333" />-->
                    </div>
                </div>
            </div>
        </div>

        <div id="statusview" v-if="orderStatus == 1">
            <div class="audithome_cont">
                <div class="audithome_cview">
                    <div class="auditpass_wrap">
                        <!--<div class="loanstatus">
                            <img src="../../assets/img/loansuccess.webp" alt="">
                        </div>
                        <div class="loanstatus_text">
                            Hay retraso bancario en el proceso del envío de dinero, le avisaremos por SMS cuando la transferencia sea exitosa.
                        </div>
                        <div class="loanstatus_text">
                            El depósito sería atrasado durante los días no laborales.
                        </div>-->

                        <div class="loan-status">
                            <div class="contant">
                                <div class="contant__card">
                                    <img :src="statuMsg[status].img" alt="" />
                                    <p>
                                        {{ statuMsg[status].label }}
                                    </p>
                                    <span> {{ statuMsg[status].des }} </span>
                                </div>
                                <div class="review-remark" v-if="status == '1'">
                                    <div class="review-remark__label">
                                        <img src="@/assets/imgs/tips_icon.webp" alt="" />
                                        <span>Consejos Superapoyomax</span>
                                    </div>
                                    <p v-for="(item, index) in reviewDes[isReloan]" :key="index">
                                        {{ item }}
                                    </p>
                                </div>

                                <template v-if="diversionLink">
                                    <div class="reject-remark" v-if="status == '2' && diversionLink.length > 0">
                                        <div class="reject-remark__des">
                                            Le recomendamos los siguientes productos con altas tasas de aprobación para su
                                            consideración:
                                        </div>

                                        <div v-for="(item, index) in diversionLink" class="link-item" :key="index">
                                            <div class="contant-flex">
                                                <img class="link-item__logo" :src="item.es_logo_ur" alt="" />
                                                <div class="link-item__des">
                                                    <p>{{ item.de_app_nm }}</p>
                                                    <span>{{ item.in_paquete_em }}</span>
                                                </div>
                                            </div>
                                            <div class="link-item__btn">
                                                Solicitar
                                            </div>
                                        </div>

                                        <div class="expandinfo_btns">
                                            <van-button block color="#C3C3C3" round style="height: 44px">
                                                <span style="font-size: 16px; font-weight: 500">COMPLETAR</span>
                                            </van-button>
                                        </div>
                                    </div>
                                </template>

                                <div class="rayment-in" v-if="status == '3'">
                                    <div class="rayment-in__left">
                                        <img src="@/assets/imgs/payment-icon-one.webp" alt="" />
                                        <div class="line"></div>
                                        <img class="rotate" src="@/assets/imgs/payment-icon-two.webp" alt="" />
                                        <div class="line-two"></div>
                                        <img src="@/assets/imgs/payment-icon-three.webp" alt="" />
                                    </div>
                                    <div class="rayment-in__right">
                                        <p class="rayment-in__right__one">Verificación hecha</p>
                                        <p>Depositando por parte de banco</p>
                                        <h4 class="rayment-in__right__two" v-if="loanInfo">
                                            Normalmente toma 2 minutos para depositar, el tiempo depende de la velocidad de
                                            transferencia del banco (el último número de su cuenta receptora es
                                            {{ getLastStr(loanInfo.na_bancaria_no) }})
                                        </h4>
                                        <p class="rayment-in__right__three">Depósito exitoso</p>
                                    </div>
                                </div>
                                <div class="loan-fail" v-if="status == '4'">
                                    <div class="loan-fail__label">
                                        <img src="@/assets/imgs/tips_icon.webp" alt="" />
                                        <p>
                                            Lamentablemente, el depósito desde banco a tu cuenta fue fracasado. Te recomendamos que
                                        </p>
                                    </div>
                                    <div class="loan-fail__remarks">
                                        <p>① Cambia otra tarjeta</p>
                                        <p>② Esperar unos minutos y da clic en ¨Depositar de nuevo</p>
                                    </div>
                                    <div class="loan-fail__btns">
                                        <div class="loan-fail__btn" @click.stop="editCard"> DEPOSITAR DE NUEVO </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


            <!--<div style="width: 80%; margin: 0 auto;">
                <div class="eshoy_slider_btns">
                    <div class="eshoy_slider_btn_view" @click="onConfirm">
                        <van-button color="linear-gradient(to top, #0F9F52, #2DDD7F)" block style="height: 1.111111rem; border-radius: 8px;">
                            <span style="font-weight: 500;">Applyling for a loan</span>
                        </van-button>
                    </div>
                </div>
            </div>-->

        </div>

        <div class="auditcommon_cont">
            <div class="auditcommon_thr">
                <img src="../../assets/img/homefooter_icon05.jpg" />
            </div>
        </div>

        <van-tabbar v-model="tabactive" active-color="#19A95C" inactive-color="#999999" @change="onTabChange">
            <van-tabbar-item icon="wap-home">Inicio</van-tabbar-item>
            <van-tabbar-item icon="contact">Yo</van-tabbar-item>
        </van-tabbar>
        </van-pull-refresh>
    </div>
</template>

<script>

    import reviewImg from '@/assets/img/loan_status_review.webp';
    import rejectImg from '@/assets/img/loan_status_reject.webp';

    import { getTimezoneName, getUserIp } from '@/utils/commonParams';
    import { loadingShow, loadingHide } from '@/utils/loading'
    import { getAccessToken } from '@/utils/auth';

    import { getLoanInfo } from '@/api/loan'

    import { Toast } from 'vant';

    export default {
        data() {
            return {
                tabactive: 0,
                loanStatus: null,
                orderStatus: 2,
                status: 1,
                isReloan: 1,
                loanInfo: {},
                generateuuId: '',
                statuMsg: {
                    1: {
                        img: reviewImg,
                        label:
                            'Superapoyomax se está apresurando para darle una revisión. Generalmente solo toma unos minutos',
                        des: 'Se recomienda que vuelva a la aplicación más tarde para comprobar los resultados de la revisión o esperar a nuestra notificación por SMS.',
                    },
                    2: {
                        img: rejectImg,
                        label: 'Verificación fallada',
                        des: 'Lo sentimos, tu solicitud no ha sido aprobada debido a una puntuación de crédito insuficiente. Puedes volver a solicitar después de 7 días.',
                    },
                    3: {
                        img: reviewImg,
                        label: 'Procesando depósito…',
                        des: '',
                    },
                    4: {
                        img: rejectImg,
                        label: 'Depósito fallado',
                        des: '',
                    },
                },
                reviewDes: {
                    0: [
                        'No olvides volver a entrar a la aplicación para dar confirmación a tu pedido aprobado. Despúes de confirmación, depositaremos dinero a tu cuenta bancaria en pocos minutos. ',
                        'Para evitar riesgo potencial, nuestro asesor de atención al clientes pondrá en contacto contigo para verificar información. En general la llamada de verificación se realiza dentro de un día hábil. ',
                    ],
                    1: [
                        '① Para situaciones de riesgo, podemos contactarlo por teléfono para verificar la información. Por lo general, nos pondremos en contacto dentro de un día hábil.',
                    ],
                },
                diversionLink: [],
                isInfoLoading: false,
            }
        },
        mounted() {
            this.gotoStatus();
        },
        methods: {
            editCard() {
                this.$router.replace({
                    path: '/loanpage/applybank',
                    query: {
                        isreject: 1,
                    }
                })
            },
            getLastStr:(str) => {
                return str?.slice(-3);
            },
            onTabChange(item) {
                if(item == 0){
                    this.$router.replace({
                        path: '/loanpage/loanstatus'
                    })
                } else if(item == 1){
                    this.$router.push({
                        path: '/loanpage/usercenter'
                    })
                }
            },
            onConfirm() {
                this.$router.push({
                    path: '/loanpage/reapeatloan'
                });
            },
            onRefresh() {
                this.isInfoLoading = true;
                this.gotoStatus();
            },
            async gotoStatus() {
                let _this = this;
                const login_token = getAccessToken();
                console.log(login_token)
                if(login_token){ //已经登录
                    console.log('已登录11111')
                    let time_zone = getTimezoneName();
                    console.log(time_zone);
                    loadingShow();
                    let ip = await getUserIp()
                    console.log(ip)

                    let postData = {
                        zzm_yya_hqb: getAccessToken(),
                        aaa_off_csl: '111',
                    };

                    let headerParams = {
                        'ad-justad-id': localStorage.getItem("adjust_id"),
                        'ad-justad-j': '',
                        'ad-justad-idfv': '',
                    };

                    loadingShow();
                    getLoanInfo(postData, {
                        'bwd-irh-lnf': time_zone,
                        'xfo-plp-van': ip,
                        ...headerParams
                    }).then(res => {
                        console.log(res)
                        loadingHide()
                        this.isInfoLoading = false;
                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                let useDataJSON = JSON.parse(useData);
                                let { vkt_fnd_yzo, ojq_dzg_oxq } = useDataJSON;
                                //order_status, reapply_time, current_is_reloan,
                                let { omi_fje_qly, huw_kdq_nxo, xhi_cur_ovl } = vkt_fnd_yzo;

                                console.log(omi_fje_qly);
                                console.log(huw_kdq_nxo);
                                console.log(ojq_dzg_oxq);
                                console.log(xhi_cur_ovl);

                                //               order_status, reapply_time, server_time, current_is_reloan,
                                //this.getStatus(omi_fje_qly, huw_kdq_nxo, ojq_dzg_oxq, xhi_cur_ovl, _this);

                                this.getStatus(omi_fje_qly, huw_kdq_nxo, ojq_dzg_oxq, xhi_cur_ovl, _this);

                            }
                        } else {
                            Toast(res.ms);
                        }
                    }, error => {
                        loadingHide()
                        this.isInfoLoading = false;
                    });
                } else { //未登录
                    console.log('未登录1111')
                    this.$router.replace({
                        path: '/loanpage/loginhome'
                    })
                    //this.gotoLogin();
                }
            },
            getStatus: (value, reapply_time, server_time, current_is_reloan, _this) => {
                switch (value) {
                    case 0:
                    case 10:
                    case 15:
                    case 17:
                    case 21:
                        console.log('0没有申请过,10失效,15展期结清,17展期失效,21等待签约');
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = null;
                            }
                        } else {
                            _this.isReloan = null;
                        }

                        if(_this.isReloan == 1){
                            _this.$router.replace({
                                path: '/loanpage/reapeatloan'
                            });
                        } else {
                            _this.$router.replace({
                                path: '/loanpage/applyhome'
                            });
                        }
                        break;
                    case 1:
                    case 2:
                    case 4:
                    case 13:
                    case 18:
                    case 19:
                    case 20:
                        console.log('//1提交申请,2提交审核,4等待人工审核,17展期失效,21等待签约');
                        _this.orderStatus = 1;
                        _this.loanStatus = 1;
                        _this.status = 1;
                        break;
                    case 3:
                        console.log('//审核拒绝');
                        if (_this.canReloanByTime(reapply_time, server_time)) {
                            _this.orderStatus = 2;
                            /*if (_this.isReloan) {
                                if(current_is_reloan != undefined){
                                    if(current_is_reloan == 1){
                                        _this.isReloan = 1;
                                    } else {
                                        _this.isReloan = 1;
                                    }
                                } else {
                                    _this.isReloan = 1;
                                }
                                _this.$router.replace({
                                    path: '/loanpage/reapeatloan'
                                });
                            } else {

                            }*/

                            if(current_is_reloan != undefined){
                                if(current_is_reloan == 1){
                                    _this.isReloan = 1;
                                } else {
                                    _this.isReloan = null;
                                }
                            } else {
                                _this.isReloan = null;
                            }

                            if(_this.isReloan == 1){
                                _this.$router.replace({
                                    path: '/loanpage/reapeatloan'
                                });
                            } else {
                                _this.$router.replace({
                                    path: '/loanpage/applyhome'
                                });
                            }
                        } else {
                            _this.orderStatus = 1;
                            _this.loanStatus = 2;
                            _this.status = 2;
                        }
                        break;
                    case 5:
                    case 12:
                        console.log('//5等待放款，12正在放款中');
                        _this.orderStatus = 1;
                        _this.loanStatus = 3;
                        _this.status = 3;
                        break;
                    case 6:
                        console.log('//放款失败');
                        _this.orderStatus = 1;
                        _this.loanStatus = 4;
                        _this.status = 4;
                        break;
                    case 7:
                    case 9:
                    case 11:
                    case 14:
                    case 16:
                        console.log('7等待还款，9逾期，11部分还款，14等待展期，16展期申请中');
                        _this.orderStatus = 3;

                        _this.$router.replace({
                            path: '/loanpage/repayment'
                        });
                        break;
                    case 8:
                        console.log('8已结清');
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = 1;
                            }
                        } else {
                            _this.isReloan = 1;
                        }
                        _this.$router.replace({
                            path: '/loanpage/reapeatloan'
                        });
                        break;
                    case 22:
                        console.log('22等待订单再次确认, 此处掉用确认放款');
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = 0;
                            }

                        } else {
                            _this.isReloan = 0;
                        }

                        _this.$router.replace({
                            path: '/loanpage/firstloan'
                        });

                        break;
                    default:
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = null;
                            }
                        } else {
                            _this.isReloan = null;
                        }

                        if(_this.isReloan == 1){
                            _this.$router.replace({
                                path: '/loanpage/reapeatloan'
                            });
                        } else {
                            _this.$router.replace({
                                path: '/loanpage/applyhome'
                            });
                        }
                }
            },
            canReloanByTime(repTime, stime) {
                return repTime < stime;
            },
        }
    }
</script>

<style lang="scss" scoped>
    .audithome_wrap{
        width: 100%;
        height: 9.861111rem;
        background: linear-gradient(180deg, #19A95C 0%, #F6F6F6 100%);
    }
    .audithome_head{
        width: 100%;
        height: 1.333333rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding: 0 0.444444rem;
    }
    .audithome_hleft{
        width: 5.555556rem;
        height: 0.583333rem;
        font-size: 0.5rem;
        font-weight: 500;
        color: #FFFFFF;
    }
    .audithome_hright{
        width: 1.361111rem;
        height: 0.5rem;
        display: flex;
        justify-content: space-between;
    }
    .audithome_hrimg{
        width: 0.5rem;
        height: 0.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .audithome_hrimg img{
        display: block;
        width: 0.5rem;
        height: 0.5rem;
    }

    .infoBox {
        padding: 0.8rem 0.8rem 0.8rem 0.84rem;
        background: #ffffff;
        border-radius: 0.4rem;
        margin-bottom: 0.6rem;
        & > p {
            font-family: Roboto, Roboto;
            font-weight: 400;
            font-size: 0.52rem;
            color: #333333;
            line-height: 0.70rem;
            margin-top: 0.6rem;
        }
        h3 {
            text-align: left;
            font-family: Roboto, Roboto;
            font-weight: 700;
            font-size: 0.64rem;
            color: #333333;
            margin-bottom: 0.2rem;
        }
        ul {
            li {
                display: flex;
                font-family: Roboto, Roboto;
                font-weight: 400;
                color: #333333;
                margin-bottom: 0.6rem;
                p {
                    font-family: Roboto, Roboto;
                    font-weight: 400;
                    font-size: 0.4rem;
                    color: #666666;
                }
                img {
                    width: 0.6rem;
                    height: 0.6rem;
                    margin: 0.14rem 0.2rem 0 0;
                    vertical-align: middle;
                }
            }
        }
    }

    .auditcommon_cont{
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 0.833333rem 0.416667rem;
    }
    .auditcommon_thr{
        width: 100%;
        height: auto;
    }
    .auditcommon_thr img{
        display: block;
        width: 100%;
    }

    #statusview .audithome_cont{
        width: 100%;
        height: auto;
        position: relative;
    }
    #statusview  .audithome_cview{
        width: 100%;
        height: auto;
    }
    #statusview  .auditpass_wrap{
        width: 100%;
        height: auto;
        position: relative;
    }
    .auditrejection_wrap{
        width: 100%;
        height: auto;
        position: relative;
    }
    .auditrejection_bgimg{
        display: block;
        width: 100%;
    }
    .auditrejection_cont{
        width: 100%;
        height: 100vh;
        position: absolute;
        left: 0;
        top: 0;
        box-sizing: border-box;
        padding-top: 5.527778rem;
    }
    .auditrejection_wrap .auditpass_title{
        width: 100%;
        height: 0.972222rem;
        font-size: 0.583333rem;
        font-weight: bold;
        color: #333333;
        line-height: 0.583333rem;
        text-align: center;
    }
    .auditrejection_wrap .auditpass_desc{
        width: 92.22%;
        height: auto;
        margin: 0 auto;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #666666;
        line-height: 0.472222rem;
        text-align: center;
    }
    .auditrejection_wrap .auditpass_btns{
        width: 92.22%;
        height: 1.222222rem;
        margin: 1.666667rem auto 0 auto;
    }
    .loanstatus{
        width: 100%;
        height: auto;
    }
    .loanstatus img{
        display: block;
        width: 100%;
        height: 5.25rem;
    }
    .loanstatus_text{
        width: 80%;
        height: auto;
        margin: 0 auto;
        font-size: 14px;
        color: #333333;
    }

    .loan-status {
        margin: 0 0.388889rem;
    }
    .contant {
        margin-top: 10px;
        &__card {
            padding: 25px 20px 30px 20px;
            background: #ffffff;
            border-radius: 10px;
            display: grid;
            place-items: center;
            text-align: center;
            img {
                width: 133px;
            }
            p {
                font-size: 16px;
                font-family: Roboto-Medium, Roboto;
                font-weight: 500;
                color: #1a1a1a;
                line-height: 18px;
                margin: 5px 0 12px 0;
            }
            span {
                font-size: 12px;
                font-family: Roboto-Regular, Roboto;
                font-weight: 400;
                color: #69706e;
                line-height: 14px;
            }
        }
        .review-remark {
            margin-top: 29px;
            &__label {
                display: flex;
                align-items: center;
                margin-bottom: 38px;
                img {
                    width: 16px;
                    margin-right: 4px;
                }
                span {
                    font-size: 14px;
                    font-family: Roboto-Medium, Roboto;
                    font-weight: 500;
                    color: #1a1a1a;
                    line-height: 14px;
                }
            }
            p {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #69706e;
                line-height: 14px;
                margin-bottom: 12px;
            }
        }
        .reject-remark {
            margin-top: 15px;
            background: #ffffff;
            border-radius: 10px;
            &__des {
                width: 100%;
                height: 135px;
                background-image: url('../../assets/img/reject_des_bg.webp');
                background-size: 100% 100%;
                padding: 19px 111px 0 15px;

                font-size: 14px;
                font-family: Roboto-Regular, Roboto;
                font-weight: 400;
                color: #393f3d;
                line-height: 16px;
            }
            .link-item {
                padding: 16px 0;
                margin: 0 16px;
                border-bottom: 1px solid #e7e7e7;
                display: flex;
                align-items: center;
                justify-content: space-between;

                &__logo {
                    width: 45px;
                    height: 45px;
                    background: #f4f5f4;
                    border-radius: 6px;
                }
                &__des {
                    width: 143px;
                    margin-left: 13px;
                    p {
                        font-size: 14px;
                        font-family: Roboto-Medium, Roboto;
                        font-weight: 500;
                        color: #1a1a1a;
                        line-height: 14px;
                        margin-bottom: 5px;
                    }
                    span {
                        font-size: 12px;
                        font-family: Roboto-Regular, Roboto;
                        font-weight: 400;
                        color: #69706e;
                        line-height: 12px;
                    }
                }
                &__btn {
                    padding: 8px 10px;
                    font-size: 11px;
                    font-family: Roboto-Regular, Roboto;
                    font-weight: 400;
                    color: #ffffff;
                    line-height: 11px;
                    background: #006747;
                    border-radius: 22px;
                }
            }

            .link-item:nth-last-of-type(1) {
                border-bottom: none;
            }
            .contant-flex {
                display: flex;
                align-items: center;
            }
        }
        .rayment-in {
            display: flex;
            justify-content: center;
            margin: 30px 21px 30px 15px;
            &__left {
                width: 34px;
                height: 175px;
                margin-right: 12px;
                display: grid;
                place-items: center;
                font-size: 0;
                img {
                    width: 24px;
                    height: 24px;
                }
                .line {
                    width: 2px;
                    height: 14px;
                    background: #69706e;
                }
                .line-two {
                    width: 2px;
                    height: 59px;
                    background: #aacbc0;
                }
            }
            &__right {
                // width: 487px;
                p {
                    font-size: 14px;
                    font-family: Roboto-Medium, Roboto;
                    font-weight: 500;
                    color: #1a1a1a;
                    line-height: 14px;
                }
                h4 {
                    font-size: 11px;
                    font-family: Roboto-Regular, Roboto;
                    font-weight: 400;
                    color: #69706e;
                    line-height: 14px;
                }
                &__one {
                    margin: 13px 0 26px 0;
                }
                &__two {
                    margin: 8px 0 20px 0;
                }
            }
        }
        .loan-fail {
            margin: 29px 0 14px 0;
            &__label {
                display: flex;
                margin-bottom: 20px;
                img {
                    width: 16px;
                    height: 16px;
                }
                p {
                    font-size: 14px;
                    font-family: Roboto-Medium, Roboto;
                    font-weight: 500;
                    color: #1a1a1a;
                    line-height: 19px;
                    margin-left: 4px;
                }
            }
            &__remarks {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #69706e;
                line-height: 14px;
                margin-bottom: 110px;
                p {
                    margin-bottom: 12px;
                }
            }
            &__btns {
                width: 100%;
                height: 1px;
                position: relative;
            }
            &__btn {
                position: absolute;
                left: 28px;
                width: calc(100% - 56px);
                top: -40px;
                padding: 14px 0;
                background: #006747;
                border-radius: 15px;
                text-align: center;
                font-size: 16px;
                font-family: Roboto-Medium, Roboto;
                font-weight: 500;
                color: #ffffff;
                line-height: 16px;
            }
        }


        .rotate {
            animation: rotate 12s ease-in-out infinite;
        }

        @keyframes rotate {
            0% {
                transform: rotate(0deg);
            }
            100% {
                transform: rotate(3600deg);
            }
        }
    }


</style>